/**
 * Returns true if the given pathname is a homepage route (where auto-navigation is allowed).
 * Allowlist mirrors the AppHome routes in Sudowrite.js: exact `/app` and exact `/app/folder/:folderId`
 * (one non-empty segment, optional trailing slash — matching React Router's non-strict exact match).
 */
export const isHomePath = (pathname = "") => {
  if (pathname === "/app" || pathname === "/app/") return true;
  return /^\/app\/folder\/[^/]+\/?$/.test(pathname);
};
